// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewNoteMenu-module__font-s-10___LKHQZ {
  font-size: 10px !important;
}

.NewNoteMenu-module__font-s-12___o8UUF {
  font-size: 12px !important;
}

.NewNoteMenu-module__font-s-13___JVcNY {
  font-size: 13px !important;
}

.NewNoteMenu-module__font-s-14___V4XPc {
  font-size: 14px !important;
}

.NewNoteMenu-module__font-s-15___aZew3 {
  font-size: 15px !important;
}

.NewNoteMenu-module__font-s-16___r2ykZ {
  font-size: 16px !important;
}

.NewNoteMenu-module__font-s-18___FrRcd {
  font-size: 18px !important;
}

.NewNoteMenu-module__font-s-20___m_NbS {
  font-size: 20px !important;
}

.NewNoteMenu-module__font-s-22___O05XJ {
  font-size: 22px !important;
}

.NewNoteMenu-module__font-s-28___eOSbb {
  font-size: 28px !important;
}

.NewNoteMenu-module__font-w-400____BJ4N {
  font-weight: 400 !important;
}

.NewNoteMenu-module__font-w-500___hnxEJ {
  font-weight: 500 !important;
}

.NewNoteMenu-module__font-w-600___cUXWS {
  font-weight: 600 !important;
}

.NewNoteMenu-module__font-w-700___icLOO {
  font-weight: 700 !important;
}

.NewNoteMenu-module__p-5___zocwm {
  padding: 5px !important;
}

.NewNoteMenu-module__p-12___VSvl0 {
  padding: 12px !important;
}

.NewNoteMenu-module__p-16___U8pZh {
  padding: 16px !important;
}

.NewNoteMenu-module__p-30___gz7Ah {
  padding: 30px !important;
}

.NewNoteMenu-module__p-b-0___bU63R {
  padding-bottom: 0 !important;
}

.NewNoteMenu-module__p-b-5___I8tVD {
  padding-bottom: 5px !important;
}

.NewNoteMenu-module__p-b-10___LpVks {
  padding-bottom: 10px !important;
}

.NewNoteMenu-module__p-b-12___bOddt {
  padding-bottom: 12px !important;
}

.NewNoteMenu-module__p-b-16___yw8mO {
  padding-bottom: 16px !important;
}

.NewNoteMenu-module__p-b-18___Q2hgf {
  padding-bottom: 18px !important;
}

.NewNoteMenu-module__p-b-20___ApWt6 {
  padding-bottom: 20px !important;
}

.NewNoteMenu-module__p-b-25___I0VOZ {
  padding-bottom: 25px !important;
}

.NewNoteMenu-module__p-b-30___WExlm {
  padding-bottom: 30px !important;
}

.NewNoteMenu-module__p-b-50___M8s4Q {
  padding-bottom: 50px !important;
}

.NewNoteMenu-module__p-t-0___zbc0G {
  padding-top: 0 !important;
}

.NewNoteMenu-module__p-t-12___tH2IZ {
  padding-top: 12px !important;
}

.NewNoteMenu-module__p-t-16___a4KxI {
  padding-top: 16px !important;
}

.NewNoteMenu-module__p-t-18___MAXIL {
  padding-top: 18px !important;
}

.NewNoteMenu-module__p-t-20___UN2_A {
  padding-top: 20px !important;
}

.NewNoteMenu-module__p-t-30___FLgzu {
  padding-top: 30px !important;
}

.NewNoteMenu-module__p-t-40___n9DEh {
  padding-top: 40px !important;
}

.NewNoteMenu-module__p-t-50___Xn20R {
  padding-top: 50px !important;
}

.NewNoteMenu-module__p-l-20___lc5bS {
  padding-left: 20px !important;
}

.NewNoteMenu-module__p-l-30___t_EMN {
  padding-left: 30px !important;
}

.NewNoteMenu-module__p-l-40____u6SC {
  padding-left: 40px !important;
}

.NewNoteMenu-module__p-r-16___KvAg_ {
  padding-right: 16px !important;
}

.NewNoteMenu-module__p-r-20___F6Pr7 {
  padding-right: 20px !important;
}

.NewNoteMenu-module__p-r-30___FIQvn {
  padding-right: 30px !important;
}

.NewNoteMenu-module__p-r-50___y34Ja {
  padding-right: 50px !important;
}

.NewNoteMenu-module__p-r-60___b9G7b {
  padding-right: 60px !important;
}

.NewNoteMenu-module__m-b-1___zDsV7 {
  margin-bottom: 1px !important;
}

.NewNoteMenu-module__m-b-2___rRrbr {
  margin-bottom: 2px !important;
}

.NewNoteMenu-module__m-b-6___vvh2z {
  margin-bottom: 6px !important;
}

.NewNoteMenu-module__m-b-8___KrQvs {
  margin-bottom: 8px !important;
}

.NewNoteMenu-module__m-b-10___rgivj {
  margin-bottom: 10px !important;
}

.NewNoteMenu-module__m-b-14___Yd53e {
  margin-bottom: 14px !important;
}

.NewNoteMenu-module__m-b-16___yzR4c {
  margin-bottom: 16px !important;
}

.NewNoteMenu-module__m-b-20___eKQds {
  margin-bottom: 20px !important;
}

.NewNoteMenu-module__m-b-22___W9xq9 {
  margin-bottom: 22px !important;
}

.NewNoteMenu-module__m-b-24___F250R {
  margin-bottom: 24px !important;
}

.NewNoteMenu-module__m-b-30___MaEty {
  margin-bottom: 30px !important;
}

.NewNoteMenu-module__m-b-32___pk97n {
  margin-bottom: 32px !important;
}

.NewNoteMenu-module__m-b-40___qqqSN {
  margin-bottom: 40px !important;
}

.NewNoteMenu-module__m-t-2___nC3vf {
  margin-top: 2px !important;
}

.NewNoteMenu-module__m-t-3___kEWj0 {
  margin-top: 3px !important;
}

.NewNoteMenu-module__m-t-4___SEtoH {
  margin-top: 4px !important;
}

.NewNoteMenu-module__m-t-5___nrrW5 {
  margin-top: 5px !important;
}

.NewNoteMenu-module__m-t-8___aQ8QZ {
  margin-top: 8px !important;
}

.NewNoteMenu-module__m-t-10___Qe5jU {
  margin-top: 10px !important;
}

.NewNoteMenu-module__m-t-15___Kwjte {
  margin-top: 15px !important;
}

.NewNoteMenu-module__m-t-16___lmXqr {
  margin-top: 16px !important;
}

.NewNoteMenu-module__m-t-20___ZRf3N {
  margin-top: 20px !important;
}

.NewNoteMenu-module__m-t-22___IEApl {
  margin-top: 22px !important;
}

.NewNoteMenu-module__m-t-30___UZcxd {
  margin-top: 30px !important;
}

.NewNoteMenu-module__m-t-32___qcf_B {
  margin-top: 32px !important;
}

.NewNoteMenu-module__m-l-auto___PQYHh {
  margin-left: auto !important;
}

.NewNoteMenu-module__m-l-4___vhhrd {
  margin-left: 4px !important;
}

.NewNoteMenu-module__m-l-5___FZHDD {
  margin-left: 5px !important;
}

.NewNoteMenu-module__m-l-6___tfSHZ {
  margin-left: 6px !important;
}

.NewNoteMenu-module__m-l-8___HJxh5 {
  margin-left: 8px !important;
}

.NewNoteMenu-module__m-l-10___T6YH0 {
  margin-left: 10px !important;
}

.NewNoteMenu-module__m-l-16___knwBQ {
  margin-left: 16px !important;
}

.NewNoteMenu-module__m-l-20___ElPoe {
  margin-left: 20px !important;
}

.NewNoteMenu-module__m-l-24___y9_gD {
  margin-left: 24px !important;
}

.NewNoteMenu-module__m-l-30___d26yF {
  margin-left: 30px !important;
}

.NewNoteMenu-module__m-l-35____N5dh {
  margin-left: 35px !important;
}

.NewNoteMenu-module__m-l-40___kPJR1 {
  margin-left: 40px !important;
}

.NewNoteMenu-module__m-r-8___Fk5QV {
  margin-right: 8px !important;
}

.NewNoteMenu-module__m-r-10___YUYcf {
  margin-right: 10px !important;
}

.NewNoteMenu-module__m-r-16___z9LXk {
  margin-right: 16px !important;
}

.NewNoteMenu-module__m-r-20___nw3AM {
  margin-right: 20px !important;
}

.NewNoteMenu-module__m-r-24___FC2jq {
  margin-right: 24px !important;
}

.NewNoteMenu-module__m-r-30___ibs4q {
  margin-right: 30px !important;
}

.NewNoteMenu-module__m-r-40___jVQr5 {
  margin-right: 40px !important;
}

.NewNoteMenu-module__border-r-3___zu5mu {
  border-radius: 3px !important;
}

.NewNoteMenu-module__border-r-4___oYBUz {
  border-radius: 4px !important;
}

.NewNoteMenu-module__border-r-6___jhJva {
  border-radius: 6px !important;
}

.NewNoteMenu-module__border-r-10___TSCli {
  border-radius: 10px !important;
}

.NewNoteMenu-module__border-r-12___dtSlh {
  border-radius: 12px !important;
}

.NewNoteMenu-module__border-r-16___yVKPg {
  border-radius: 16px !important;
}

.NewNoteMenu-module__border-r-50___wPucl {
  border-radius: 50% !important;
}

.NewNoteMenu-module__primary-border___v8wMc {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.NewNoteMenu-module__primary-border-b___3cqwh {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.NewNoteMenu-module__primary-border-t___pgUH8 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.NewNoteMenu-module__primary-border-l___WsSQ0 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.NewNoteMenu-module__primary-border-r___Mynec {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.NewNoteMenu-module__secondary-border___Hhhwq {
  border: 1px solid #637768;
}

.NewNoteMenu-module__secondary-border-b___lGKHW {
  border-bottom: 1px solid #637768;
}

.NewNoteMenu-module__secondary-border-t___PcwDp {
  border-top: 1px solid #637768;
}

.NewNoteMenu-module__secondary-border-l___hX8S2 {
  border-left: 1px solid #637768;
}

.NewNoteMenu-module__secondary-border-r___o2Bde {
  border-right: 1px solid #637768;
}

.NewNoteMenu-module__gap-0___TWBYL {
  gap: 0 !important;
}

.NewNoteMenu-module__gap-2___UsmNG {
  gap: 2px !important;
}

.NewNoteMenu-module__gap-4___XcSUB {
  gap: 4px !important;
}

.NewNoteMenu-module__gap-5___tFBrG {
  gap: 5px !important;
}

.NewNoteMenu-module__gap-6___GLjPN {
  gap: 6px !important;
}

.NewNoteMenu-module__gap-8___KQ0Ft {
  gap: 8px !important;
}

.NewNoteMenu-module__gap-10___wmD6J {
  gap: 10px !important;
}

.NewNoteMenu-module__gap-12___XhN_b {
  gap: 12px !important;
}

.NewNoteMenu-module__gap-14___kx3jR {
  gap: 14px !important;
}

.NewNoteMenu-module__gap-16___X10Jm {
  gap: 16px !important;
}

.NewNoteMenu-module__gap-18___rxJIy {
  gap: 18px !important;
}

.NewNoteMenu-module__gap-20___CH32k {
  gap: 20px !important;
}

.NewNoteMenu-module__gap-24___dR2vE {
  gap: 24px !important;
}

.NewNoteMenu-module__gap-26___KFUxn {
  gap: 26px !important;
}

.NewNoteMenu-module__gap-30___tG3UV {
  gap: 30px !important;
}

.NewNoteMenu-module__gap-32___ztpe2 {
  gap: 32px !important;
}

.NewNoteMenu-module__gap-40___uKOWr {
  gap: 40px !important;
}

.NewNoteMenu-module__gap-50___HMfx4 {
  gap: 50px !important;
}

.NewNoteMenu-module__flex-1___EGhlA {
  flex: 1;
}

.NewNoteMenu-module__flex-none___VaNE4 {
  flex: none !important;
}

.NewNoteMenu-module__flex-column___fqTYQ {
  display: flex;
  flex-direction: column !important;
}

.NewNoteMenu-module__flex-row___SzBve {
  display: flex;
  flex-direction: row !important;
}

.NewNoteMenu-module__vertically-centered___BSs9b {
  display: flex;
  align-items: center !important;
}

.NewNoteMenu-module__horizontally-centered___CGbFr {
  display: flex;
  justify-content: center !important;
}

.NewNoteMenu-module__horizontally-end___QJ8o4 {
  display: flex;
  justify-content: end !important;
}

.NewNoteMenu-module__vertically-start___gYTkt {
  display: flex;
  align-items: start !important;
}

.NewNoteMenu-module__space-between___BIjAM {
  display: flex;
  justify-content: space-between !important;
}

.NewNoteMenu-module__flex-wrap___lkPoK {
  flex-wrap: wrap !important;
}

.NewNoteMenu-module__height-100___tYO_O {
  height: 100%;
}

.NewNoteMenu-module__width-50___TrpOz {
  width: 50% !important;
}

.NewNoteMenu-module__width-100___w_HCx {
  width: 100%;
}

.NewNoteMenu-module__cursor-pointer___dlQl5 {
  cursor: pointer;
}

.NewNoteMenu-module__cursor-not-allowed___wpTn1 {
  cursor: not-allowed !important;
}

.NewNoteMenu-module__absolute-centered___ZTlfG {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.NewNoteMenu-module__absolute___Aak_6 {
  position: absolute;
}

.NewNoteMenu-module__relative___mkuSi {
  position: relative;
}

.NewNoteMenu-module__fixed___XTNcT {
  position: fixed;
}

.NewNoteMenu-module__visible___Le43t {
  opacity: 1;
}

.NewNoteMenu-module__invisible___RkJlJ {
  opacity: 0;
}

.NewNoteMenu-module__col-90___t6kLs {
  width: 90% !important;
}

.NewNoteMenu-module__col-auto___Ph6Q8 {
  width: auto !important;
}

.NewNoteMenu-module__medical-tabs___TlqsM {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.NewNoteMenu-module__medical-table-new___Pk25o {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NewNoteMenu-module__medical-table-new___Pk25o:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NewNoteMenu-module__medical-table-new___Pk25o::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NewNoteMenu-module__medical-table-new___Pk25o::-webkit-scrollbar-track {
  display: none;
}
.NewNoteMenu-module__medical-table-new___Pk25o.NewNoteMenu-module__no-pagination___SbnY_ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NewNoteMenu-module__medical-table-new___Pk25o.NewNoteMenu-module__no-pagination___SbnY_:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NewNoteMenu-module__medical-table-new___Pk25o.NewNoteMenu-module__no-pagination___SbnY_::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NewNoteMenu-module__medical-table-new___Pk25o.NewNoteMenu-module__no-pagination___SbnY_::-webkit-scrollbar-track {
  display: none;
}

.NewNoteMenu-module__medical-table-empty___IwwHn {
  padding: 14px 40px !important;
}

.NewNoteMenu-module__icon-btn___ZuDDB {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.NewNoteMenu-module__search-icon___LsD8x {
  width: 24px;
  height: 24px;
  align-self: center;
}

.NewNoteMenu-module__disable-select___GQlCL {
  user-select: none;
}

.NewNoteMenu-module__break-word___NcCpB {
  word-break: break-word;
}

.NewNoteMenu-module__popup-clear-btn___Btoc1 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.NewNoteMenu-module__scroll-m-b-20___QXqzt {
  scroll-margin-bottom: 20px;
}

.NewNoteMenu-module__option___z9QTU {
  padding: 12px 14px;
  color: #375844;
}
.NewNoteMenu-module__option___z9QTU:hover {
  background-color: #f1f3e7;
}
.NewNoteMenu-module__option___z9QTU .NewNoteMenu-module__icon___fsCau {
  width: 13px;
  height: 13px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/MainNavigation/components/NewNoteMenu/NewNoteMenu.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,cAAA;AA8pBF;AA5pBE;EACE,yBAAA;AA8pBJ;AA3pBE;EACE,WAAA;EACA,YAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.option {\n  padding: 12px 14px;\n  color: get-color(greenNew, dark);\n\n  &:hover {\n    background-color: get-color(greenNew, lighter);\n  }\n\n  .icon {\n    width: 13px;\n    height: 13px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `NewNoteMenu-module__font-s-10___LKHQZ`,
	"fontS12": `NewNoteMenu-module__font-s-12___o8UUF`,
	"fontS13": `NewNoteMenu-module__font-s-13___JVcNY`,
	"fontS14": `NewNoteMenu-module__font-s-14___V4XPc`,
	"fontS15": `NewNoteMenu-module__font-s-15___aZew3`,
	"fontS16": `NewNoteMenu-module__font-s-16___r2ykZ`,
	"fontS18": `NewNoteMenu-module__font-s-18___FrRcd`,
	"fontS20": `NewNoteMenu-module__font-s-20___m_NbS`,
	"fontS22": `NewNoteMenu-module__font-s-22___O05XJ`,
	"fontS28": `NewNoteMenu-module__font-s-28___eOSbb`,
	"fontW400": `NewNoteMenu-module__font-w-400____BJ4N`,
	"fontW500": `NewNoteMenu-module__font-w-500___hnxEJ`,
	"fontW600": `NewNoteMenu-module__font-w-600___cUXWS`,
	"fontW700": `NewNoteMenu-module__font-w-700___icLOO`,
	"p5": `NewNoteMenu-module__p-5___zocwm`,
	"p12": `NewNoteMenu-module__p-12___VSvl0`,
	"p16": `NewNoteMenu-module__p-16___U8pZh`,
	"p30": `NewNoteMenu-module__p-30___gz7Ah`,
	"pB0": `NewNoteMenu-module__p-b-0___bU63R`,
	"pB5": `NewNoteMenu-module__p-b-5___I8tVD`,
	"pB10": `NewNoteMenu-module__p-b-10___LpVks`,
	"pB12": `NewNoteMenu-module__p-b-12___bOddt`,
	"pB16": `NewNoteMenu-module__p-b-16___yw8mO`,
	"pB18": `NewNoteMenu-module__p-b-18___Q2hgf`,
	"pB20": `NewNoteMenu-module__p-b-20___ApWt6`,
	"pB25": `NewNoteMenu-module__p-b-25___I0VOZ`,
	"pB30": `NewNoteMenu-module__p-b-30___WExlm`,
	"pB50": `NewNoteMenu-module__p-b-50___M8s4Q`,
	"pT0": `NewNoteMenu-module__p-t-0___zbc0G`,
	"pT12": `NewNoteMenu-module__p-t-12___tH2IZ`,
	"pT16": `NewNoteMenu-module__p-t-16___a4KxI`,
	"pT18": `NewNoteMenu-module__p-t-18___MAXIL`,
	"pT20": `NewNoteMenu-module__p-t-20___UN2_A`,
	"pT30": `NewNoteMenu-module__p-t-30___FLgzu`,
	"pT40": `NewNoteMenu-module__p-t-40___n9DEh`,
	"pT50": `NewNoteMenu-module__p-t-50___Xn20R`,
	"pL20": `NewNoteMenu-module__p-l-20___lc5bS`,
	"pL30": `NewNoteMenu-module__p-l-30___t_EMN`,
	"pL40": `NewNoteMenu-module__p-l-40____u6SC`,
	"pR16": `NewNoteMenu-module__p-r-16___KvAg_`,
	"pR20": `NewNoteMenu-module__p-r-20___F6Pr7`,
	"pR30": `NewNoteMenu-module__p-r-30___FIQvn`,
	"pR50": `NewNoteMenu-module__p-r-50___y34Ja`,
	"pR60": `NewNoteMenu-module__p-r-60___b9G7b`,
	"mB1": `NewNoteMenu-module__m-b-1___zDsV7`,
	"mB2": `NewNoteMenu-module__m-b-2___rRrbr`,
	"mB6": `NewNoteMenu-module__m-b-6___vvh2z`,
	"mB8": `NewNoteMenu-module__m-b-8___KrQvs`,
	"mB10": `NewNoteMenu-module__m-b-10___rgivj`,
	"mB14": `NewNoteMenu-module__m-b-14___Yd53e`,
	"mB16": `NewNoteMenu-module__m-b-16___yzR4c`,
	"mB20": `NewNoteMenu-module__m-b-20___eKQds`,
	"mB22": `NewNoteMenu-module__m-b-22___W9xq9`,
	"mB24": `NewNoteMenu-module__m-b-24___F250R`,
	"mB30": `NewNoteMenu-module__m-b-30___MaEty`,
	"mB32": `NewNoteMenu-module__m-b-32___pk97n`,
	"mB40": `NewNoteMenu-module__m-b-40___qqqSN`,
	"mT2": `NewNoteMenu-module__m-t-2___nC3vf`,
	"mT3": `NewNoteMenu-module__m-t-3___kEWj0`,
	"mT4": `NewNoteMenu-module__m-t-4___SEtoH`,
	"mT5": `NewNoteMenu-module__m-t-5___nrrW5`,
	"mT8": `NewNoteMenu-module__m-t-8___aQ8QZ`,
	"mT10": `NewNoteMenu-module__m-t-10___Qe5jU`,
	"mT15": `NewNoteMenu-module__m-t-15___Kwjte`,
	"mT16": `NewNoteMenu-module__m-t-16___lmXqr`,
	"mT20": `NewNoteMenu-module__m-t-20___ZRf3N`,
	"mT22": `NewNoteMenu-module__m-t-22___IEApl`,
	"mT30": `NewNoteMenu-module__m-t-30___UZcxd`,
	"mT32": `NewNoteMenu-module__m-t-32___qcf_B`,
	"mLAuto": `NewNoteMenu-module__m-l-auto___PQYHh`,
	"mL4": `NewNoteMenu-module__m-l-4___vhhrd`,
	"mL5": `NewNoteMenu-module__m-l-5___FZHDD`,
	"mL6": `NewNoteMenu-module__m-l-6___tfSHZ`,
	"mL8": `NewNoteMenu-module__m-l-8___HJxh5`,
	"mL10": `NewNoteMenu-module__m-l-10___T6YH0`,
	"mL16": `NewNoteMenu-module__m-l-16___knwBQ`,
	"mL20": `NewNoteMenu-module__m-l-20___ElPoe`,
	"mL24": `NewNoteMenu-module__m-l-24___y9_gD`,
	"mL30": `NewNoteMenu-module__m-l-30___d26yF`,
	"mL35": `NewNoteMenu-module__m-l-35____N5dh`,
	"mL40": `NewNoteMenu-module__m-l-40___kPJR1`,
	"mR8": `NewNoteMenu-module__m-r-8___Fk5QV`,
	"mR10": `NewNoteMenu-module__m-r-10___YUYcf`,
	"mR16": `NewNoteMenu-module__m-r-16___z9LXk`,
	"mR20": `NewNoteMenu-module__m-r-20___nw3AM`,
	"mR24": `NewNoteMenu-module__m-r-24___FC2jq`,
	"mR30": `NewNoteMenu-module__m-r-30___ibs4q`,
	"mR40": `NewNoteMenu-module__m-r-40___jVQr5`,
	"borderR3": `NewNoteMenu-module__border-r-3___zu5mu`,
	"borderR4": `NewNoteMenu-module__border-r-4___oYBUz`,
	"borderR6": `NewNoteMenu-module__border-r-6___jhJva`,
	"borderR10": `NewNoteMenu-module__border-r-10___TSCli`,
	"borderR12": `NewNoteMenu-module__border-r-12___dtSlh`,
	"borderR16": `NewNoteMenu-module__border-r-16___yVKPg`,
	"borderR50": `NewNoteMenu-module__border-r-50___wPucl`,
	"primaryBorder": `NewNoteMenu-module__primary-border___v8wMc`,
	"primaryBorderB": `NewNoteMenu-module__primary-border-b___3cqwh`,
	"primaryBorderT": `NewNoteMenu-module__primary-border-t___pgUH8`,
	"primaryBorderL": `NewNoteMenu-module__primary-border-l___WsSQ0`,
	"primaryBorderR": `NewNoteMenu-module__primary-border-r___Mynec`,
	"secondaryBorder": `NewNoteMenu-module__secondary-border___Hhhwq`,
	"secondaryBorderB": `NewNoteMenu-module__secondary-border-b___lGKHW`,
	"secondaryBorderT": `NewNoteMenu-module__secondary-border-t___PcwDp`,
	"secondaryBorderL": `NewNoteMenu-module__secondary-border-l___hX8S2`,
	"secondaryBorderR": `NewNoteMenu-module__secondary-border-r___o2Bde`,
	"gap0": `NewNoteMenu-module__gap-0___TWBYL`,
	"gap2": `NewNoteMenu-module__gap-2___UsmNG`,
	"gap4": `NewNoteMenu-module__gap-4___XcSUB`,
	"gap5": `NewNoteMenu-module__gap-5___tFBrG`,
	"gap6": `NewNoteMenu-module__gap-6___GLjPN`,
	"gap8": `NewNoteMenu-module__gap-8___KQ0Ft`,
	"gap10": `NewNoteMenu-module__gap-10___wmD6J`,
	"gap12": `NewNoteMenu-module__gap-12___XhN_b`,
	"gap14": `NewNoteMenu-module__gap-14___kx3jR`,
	"gap16": `NewNoteMenu-module__gap-16___X10Jm`,
	"gap18": `NewNoteMenu-module__gap-18___rxJIy`,
	"gap20": `NewNoteMenu-module__gap-20___CH32k`,
	"gap24": `NewNoteMenu-module__gap-24___dR2vE`,
	"gap26": `NewNoteMenu-module__gap-26___KFUxn`,
	"gap30": `NewNoteMenu-module__gap-30___tG3UV`,
	"gap32": `NewNoteMenu-module__gap-32___ztpe2`,
	"gap40": `NewNoteMenu-module__gap-40___uKOWr`,
	"gap50": `NewNoteMenu-module__gap-50___HMfx4`,
	"flex1": `NewNoteMenu-module__flex-1___EGhlA`,
	"flexNone": `NewNoteMenu-module__flex-none___VaNE4`,
	"flexColumn": `NewNoteMenu-module__flex-column___fqTYQ`,
	"flexRow": `NewNoteMenu-module__flex-row___SzBve`,
	"verticallyCentered": `NewNoteMenu-module__vertically-centered___BSs9b`,
	"horizontallyCentered": `NewNoteMenu-module__horizontally-centered___CGbFr`,
	"horizontallyEnd": `NewNoteMenu-module__horizontally-end___QJ8o4`,
	"verticallyStart": `NewNoteMenu-module__vertically-start___gYTkt`,
	"spaceBetween": `NewNoteMenu-module__space-between___BIjAM`,
	"flexWrap": `NewNoteMenu-module__flex-wrap___lkPoK`,
	"height100": `NewNoteMenu-module__height-100___tYO_O`,
	"width50": `NewNoteMenu-module__width-50___TrpOz`,
	"width100": `NewNoteMenu-module__width-100___w_HCx`,
	"cursorPointer": `NewNoteMenu-module__cursor-pointer___dlQl5`,
	"cursorNotAllowed": `NewNoteMenu-module__cursor-not-allowed___wpTn1`,
	"absoluteCentered": `NewNoteMenu-module__absolute-centered___ZTlfG`,
	"absolute": `NewNoteMenu-module__absolute___Aak_6`,
	"relative": `NewNoteMenu-module__relative___mkuSi`,
	"fixed": `NewNoteMenu-module__fixed___XTNcT`,
	"visible": `NewNoteMenu-module__visible___Le43t`,
	"invisible": `NewNoteMenu-module__invisible___RkJlJ`,
	"col90": `NewNoteMenu-module__col-90___t6kLs`,
	"colAuto": `NewNoteMenu-module__col-auto___Ph6Q8`,
	"medicalTabs": `NewNoteMenu-module__medical-tabs___TlqsM`,
	"medicalTableNew": `NewNoteMenu-module__medical-table-new___Pk25o`,
	"noPagination": `NewNoteMenu-module__no-pagination___SbnY_`,
	"medicalTableEmpty": `NewNoteMenu-module__medical-table-empty___IwwHn`,
	"iconBtn": `NewNoteMenu-module__icon-btn___ZuDDB`,
	"searchIcon": `NewNoteMenu-module__search-icon___LsD8x`,
	"disableSelect": `NewNoteMenu-module__disable-select___GQlCL`,
	"breakWord": `NewNoteMenu-module__break-word___NcCpB`,
	"popupClearBtn": `NewNoteMenu-module__popup-clear-btn___Btoc1`,
	"scrollMB20": `NewNoteMenu-module__scroll-m-b-20___QXqzt`,
	"option": `NewNoteMenu-module__option___z9QTU`,
	"icon": `NewNoteMenu-module__icon___fsCau`
};
module.exports = ___CSS_LOADER_EXPORT___;
